<script>
export default {
  props: {
    value: { type: [Object, Array], default: null },
    tag: { type: String, default: 'div' },
    options: { type: Object, default: () => {} }
  },
  render (createElement) {
    let nodes = this.value
    if (!Array.isArray(nodes)) {
      nodes = [nodes]
    }
    // return createElement(this.tag, this.options, nodes)
    // return this.value
    return createElement('div', { class: 'render-node' }, nodes)
  }
}
</script>

<!-- <script>
export default {
  props: {
    component: { type: [Object, Array], default: null },
    tag: { type: String, default: null },
    options: { type: Object, default: () => {} },
    props: { type: Object, default: null },
    scoped: { type: String, default: null }
  },
  render (createElement) {
    if (this.component && this.scoped && this.tag) {
      return createElement(this.tag, this.options,
        this.props
          ? this.component.$scopedSlots[this.scoped](this.props)
          : this.component.$slots[this.scoped])
    } else {
      return this.component
    }
  }
}
</script> -->
